import type { CSSProperties, ReactNode } from 'react';
import { Icon, Text } from '../../../atoms';
import { Overlay } from './Overlay';

type Props = {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  width?: number | string;
  children?: ReactNode;
  bodyStyle?: CSSProperties;
};

export function Modal({ open, onClose, title, subtitle, footer, width = 520, children, bodyStyle }: Props) {
  return (
    <Overlay open={open} onClose={onClose} style={{ alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width,
          maxWidth: '100%',
          maxHeight: 'calc(100vh - 48px)',
          background: 'var(--bg-1)',
          border: '1px solid var(--line-3)',
          boxShadow: '0 24px 60px rgba(0,0,0,0.55)',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        {(title || subtitle) && (
          <div
            style={{
              padding: '18px 22px',
              borderBottom: '1px solid var(--line-2)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 14,
              flexShrink: 0,
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              {subtitle && <Text level="meta">{subtitle}</Text>}
              {title && (
                <div style={{ marginTop: subtitle ? 4 : 0, fontSize: 18, color: 'var(--fg-max)', fontWeight: 500 }}>
                  {title}
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                width: 28,
                height: 28,
                display: 'grid',
                placeItems: 'center',
                background: 'transparent',
                color: 'var(--fg-meta)',
                border: '1px solid var(--line-2)',
                cursor: 'pointer',
                padding: 0,
                borderRadius: 2,
              }}
            >
              <Icon name="close" color="currentColor" size={10} />
            </button>
          </div>
        )}
        <div style={{ padding: 22, overflowY: 'auto', flex: 1, minHeight: 0, ...bodyStyle }}>{children}</div>
        {footer && (
          <div
            style={{
              padding: '14px 22px',
              borderTop: '1px solid var(--line-2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 8,
              flexShrink: 0,
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </Overlay>
  );
}
